var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cc-label"},[(_vm.required)?_c('div',[_c('cc-iconfont',{attrs:{"color":"red","name":"required"}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }